import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminNavbarComponent } from '../../_components/admin-navbar/admin-navbar.component';

@Component({
    selector: 'app-admin-layout',
    imports: [RouterOutlet, AdminNavbarComponent],
    template: `
    <div class="min-h-screen bg-gray-50">
      <app-admin-navbar></app-admin-navbar>
      <main class="sm:ml-64 pt-16 sm:pt-0">
        <div class="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``
})
export class AdminLayoutComponent {}
